import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import srcIconTimes from "../images/icon-times.svg"

const CompareCertifications = ({ mattresses }) => {

    const certifications = useStaticQuery(graphql`
    query {
        allDatoCmsMattressCertification(filter: {locale: {eq: "es"}}) {
            nodes {
                id
                certificationName
                certificationLogo {
                    gatsbyImageData(imgixParams: {w: "100", h: "100", fit: "scale"})
                }
            }
        }
    }
  `)

    const iconTimes = <img src={srcIconTimes} alt="✕" width="30" height="30" />

    const allCertifications = certifications.allDatoCmsMattressCertification.nodes
    const certificationRow = []
    for (let i = 0; i < allCertifications.length; i++) {
        const certificationColumn = []
        for (let j = 0; j < mattresses.length; j++) {
            let certifications = mattresses[j].certifications
            let certificationFound = false
            for (let k = 0; k < certifications.length; k++) {
                if (allCertifications[i].certificationName === certifications[k].certificationName) {
                    let cert = []
                    cert.name = allCertifications[i].certificationName
                    cert.image = allCertifications[i].certificationLogo
                    certificationColumn.push(cert)
                    certificationFound = true
                }
            }
            //lets ask if we found the size
            if (certificationFound === false) {
                //if not then lets 
                certificationColumn.push(null)
            }
        }

        //we have so many sizes so lets make sure we are not adding columns that are just null values
        let allNull = certificationColumn.every(function (v) { return v === null; });

        if (certificationColumn.length > 0) {
            if (allNull === false) {
                //at least one element of the array is not null then add
                certificationRow.push(certificationColumn)
            }
        }
    }

    //now lets iterate each row
    const htmlCertification = []
    for (let i = 0; i < certificationRow.length; i++) {
        let row = certificationRow[i]

        let auxCertification = []

        let certificationLabel = 'Cert'
        for (let j = 0; j < row.length; j++) {
            //at this point we are looking all the attributes looking for the 3 specific ones
            let column = row[j]
            if (column === null) {
                auxCertification.push(<td key={`certification-item-column-a-${j}-${i}`}>{iconTimes}</td>)
            } else {
                certificationLabel = column.name
                const image = getImage(column.image)
                auxCertification.push(<td key={`certification-item-column-a-${j}-${i}`}>
                    <GatsbyImage image={image} alt={certificationLabel} className="custom-blend" />
                </td>)
            }
        }
        htmlCertification.push(<tr key={`certification-item-row-a-${i}`}><td colSpan={mattresses.length}>{certificationLabel}</td></tr>)
        htmlCertification.push(<tr className="center-section" key={`certification-item-row-b-${i}`}>{auxCertification}</tr>)
    }

    return (
        <>
            {htmlCertification}
        </>
    )
}

export default CompareCertifications
